import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { MediaQueryPublisher } from "core/classes/media.query.publisher.class";
import { Promise } from "es6-promise-polyfill";
import { NativeContent } from "core/classes/native-content-reflow-ajax.class";

$(window).on("load", function() {
  let currentBP = MediaQueryPublisher.currentBreakpoint();

  if (!Abacus.PreventDefault.ReflowContent) {
    $("[data-reflow-content]").each(function() {
      Abacus.ReflowContent = new ReflowContent(this, MediaQueryPublisher);
      if (currentBP == "mobile") {
        currentBP = "mobile";
      }
      if (currentBP == "mobile-landscape") {
        currentBP = "mobile";
      }
      if (currentBP == "tablet-portrait") {
        currentBP = "tabletportrait";
      }
      if (currentBP == "tablet-landscape") {
        if ($("body:not(.media-master)").hasClass("story-full-layout"))
          currentBP = "tabletportrait";
        else currentBP = "tabletlandscape";
      }
      if (currentBP == "desktop") {
        if ($("body:not(.media-master)").hasClass("story-full-layout"))
          currentBP = "tabletportrait";
        else currentBP == "desktop";
      }
      Abacus.ReflowContent.triggerEvent(currentBP);
    });
  }

  // used for when widget code is dynamically loaded (advert a || advert b) page text positions
  // $("[data-ajax-param-replacement][data-load-type='dynamic']").each(function() {
  //   // console.log("%c DYNAAMMIIC", "background: #222; color: #bada55");
  //   // if (!$("body").hasClass("media-master")) {
  //   new AJAXLoadContent(this);
  //   // }
  // });
});

$(function() {
  if (!Abacus.PreventDefault.ADPosition) {
    $("[data-mpu1-reflow]").each(function() {
      new ADPositionA(this, MediaQueryPublisher);
    });
    if (document.body.id == "story" && !$("body").hasClass("microsite"))
      new ADPositionB();
  }
  // $("[data-ajax-param-replacement][data-load-type='onload']").each(function() {
  //   // console.log("%c ON LOADING", "background: red; color: white");
  //   // new AJAXLoadContent(this);
  //   $(window).on("abacus:loadcontent:complete", function(evt, context) {
  //     new StoryRHCExtra(context[0]);
  //   });
  // });
});

let ReFlowContentOptions = {
  fireEvents: false,
  moveable: false,
  elementPosition: "desktop",
  supportedMajorBreakpoints: [
    "mobile",
    "tabletportrait",
    "tabletlandscape",
    "desktop"
  ]
};

class ReflowContent extends Class {
  constructor(element, mqp, options) {
    super();
    this.element = $(element);
    this.setOptions(ReFlowContentOptions, options);
    this.mqp = mqp;
    this.bpElements = {};
    this.findPrefix();
    this.findWrapperElements();
    this.setUpEvents();
  }

  findWrapperElements() {
    var self = this;
    if (this.options.prefix) {
      $.each(this.options.supportedMajorBreakpoints, function(i, breakpoint) {
        self.bpElements[breakpoint] = $(
          "#" + self.options.prefix + "-" + breakpoint
        );
      });
      this.options.moveable = true;
    }
  }

  findPrefix() {
    var position = this.options.elementPosition;
    var wrapper = this.element.parent();
    var id = $(wrapper).attr("id");
    if (id) {
      var prefix = id.split("-" + position).join("");
      this.options.prefix = prefix;
    }
  }

  setUpEvents() {
    var self = this;
    $(this.mqp).on("abacus:newBreakpoint", function(e, breakpoint) {
      switch (breakpoint) {
        case "mobile":
          self.triggerEvent("mobile");
          break;
        case "mobile-landscape":
          self.triggerEvent("mobile");
          break;
        case "tablet-portrait":
          self.triggerEvent("tabletportrait");
          break;
        case "tablet-landscape":
          if ($("body:not(.media-master)").hasClass("story-full-layout"))
            self.triggerEvent("tabletportrait");
          else self.triggerEvent("tabletlandscape");
          break;
        case "desktop":
          if ($("body:not(.media-master)").hasClass("story-full-layout"))
            self.triggerEvent("tabletportrait");
          else self.triggerEvent("desktop");
          break;
        default:
          self.triggerEvent("desktop");
          break;
      }
    });
    this.options.fireEvents = true;
  }

  triggerEvent(breakpoint) {
    if (this.options.fireEvents && this.options.moveable) {
      var current = breakpoint;
      var element = this.bpElements[current];
      if (element.length) $(element).append(this.element);
    }
  }
}

class ADPositionA extends Class {
  constructor(element, mqp, options) {
    super();
    this.element = $(element);
    this.setOptions(options);
    this.mqp = mqp;
    this.$storyTextChildren = $(".storytext").children();
    this.$MPU1Children = this.element.children();
    this.setUpEvents();
  }

  setUpEvents() {
    var ADFlow1 = new Promise(function(resolve, reject) {
      $.ajax({
        url: "/AJAX/ADFlow1.aspx",
        success: function(data, textStatus, jqXHR) {
          resolve(data);
        }
      });
    });

    ADFlow1.then(data => {
      var mql = window.matchMedia("screen and (max-width: 1023px)");
      if ($("body").hasClass("story-full-layout")) {
        if ($(data).filter("[data-mpu-end]").length > 0) {
          $(".storytext").append(data);
        } else {
          var storyChildren = this.$storyTextChildren.filter(function(
            index,
            $item
          ) {
            return index < 4;
          });
          $(storyChildren)
            .last()
            .after(data);
        }
      } else {
        if (mql.matches) {
          if ($(data).filter("[data-mpu-end]").length > 0) {
            $(".storytext").append(data);
          } else {
            var storyChildren = this.$storyTextChildren.filter(function(
              index,
              $item
            ) {
              return index < 4;
            });
            $(storyChildren)
              .last()
              .after(data);
          }
        } else {
          $(this.element).append(data);
        }
      }
      $(window).trigger("abacus:adflow1:complete", [this.element]);
    });
  }
}

class ADPositionB extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.setOptions(options);
    this.init();
  }

  init() {
    var ADFlow2 = new Promise(function(resolve, reject) {
      $.ajax({
        url: "/AJAX/ADFlow2.aspx",
        success: function(data, textStatus, jqXHR) {
          resolve(data);
        }
      });
    });

    ADFlow2.then(function(data) {
      if ($("body").hasClass("story-full-layout")) {
        $("#story #mobile-drop-zone").append(data);
      } else {
        var mql = window.matchMedia("screen and (max-width: 1023px)");
        if (mql.matches) {
          $("#story #mobile-drop-zone").append(data);
        } else {
          $("#story #rightcolumn_sleeve").append(data);
          if ($(data).filter("[data-ajax-param-replacement]").length > 0) {
            $(window).trigger("abacus:adflow2:complete");
          }
          // used within sticky.class.js
          $(window).trigger("abacus:advertb:loaded");
        }
      }
    });
  }
}

export { ReflowContent, ADPositionA, ADPositionB };



// WEBPACK FOOTER //
// ./Javascript/core/classes/reflow.content.class.js